import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { Focus } from '@fenderdigital/ui/utils/css';
import Link from '../../../Link';

export const Container = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 7rem);
  overflow: hidden;
  z-index: 2;
  background-color: ${({ theme }): string => theme.colors.white};

  top: 3.8125rem;
  right: 0;

  ${up('tablet-portrait')} {
    top: 4.1rem;
    right: 1.3rem;
    width: 23.938rem;
    height: calc(100vh - 8.4375rem);
    max-height: 50.125rem;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.18);
  }
`;

export const MetaWrapper = styled.div`
  position: absolute;
  inset: 0;
`;

export const ContainerWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
`;

export const Span = styled.span`
  font-family: ${({ theme }): string => theme.fonts.sourceSansBold};
`;

export const ErrorButtonContainer = styled.div`
  padding: 0 1rem;
  width: 100%;
  max-width: 23.4375rem;
`;

export const ErrorCategoryContainer = styled.div`
  display: flex;
`;

export const LogoContainer = styled.div`
  width: 5.5rem;
  height: 5.5rem;
  background-color: #eff0f0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = styled(Link)`
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1.5rem;
  background-color: black;

  ${Focus};
`;

export const SectionLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  ${Focus};
`;